import { Injectable } from '@angular/core';
import {Router} from "@angular/router";
import {Subject, Subscription, tap} from "rxjs";

import {HttpHeaders} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class SharedService {



  constructor(private router: Router) {

  }

  /**
   * Defines the HTTP headers for request descriptions.
   *
   * @param {_descriptions} _descriptions - An object containing descriptions for error, success, and optional detail messages.
   * @param {_headers} [_headers] - Optional existing HTTP headers to modify. If not provided, a new HttpHeaders object is created.
   * @returns {HttpHeaders} The HTTP headers with the specified descriptions set.
   */
  DefineDescriptionHeader(_descriptions: { OnError: string, OnSuccess?: string, OnDetail?: string}, _headers: HttpHeaders | null | undefined = undefined): HttpHeaders
  {
    if(_headers)
    {
      return _headers.set('Cl-Request-Error-Description', _descriptions.OnError).set('Cl-Request-Success-Description', _descriptions.OnSuccess??"").set('Cl-Request-Detail-Description', _descriptions.OnDetail??"");
    }
    return new HttpHeaders().set('Cl-Request-Error-Description', _descriptions.OnError).set('Cl-Request-Success-Description', _descriptions.OnSuccess??"").set('Cl-Request-Detail-Description', _descriptions.OnDetail??"");
  }
}
